
















import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import Card from '@c/Card.vue';
import ModuleDeveloperActionMixin from '@/mixins/ModuleDeveloperActionMixin';
import {PMActionType} from '@/views/system/modules/enums';
import Diagram from '@/components/system/developerInfo/Diagram.vue';
import {ActionDiagramData} from '@/interfaces/diagrams';

@Component({
  components: {Card, Diagram},
})
export default class CalibrationTableAction extends Mixins(ModuleDeveloperActionMixin) {
  // хранилище
  @Prop()
  apiStore!: any;

  actionType = PMActionType.GetCalibrationTable;

  error = false;
  loading = true;

  data: ActionDiagramData = {
    values: [],
    leftX: 0,
    rightX: 0,
    size: 0,
    xTitle: 'Значение датчика',
    yTitle: 'Значение в системе СИ',
  };

  async show() {
    this.error = false;
    this.loading = true;
    this.sendAction(async () => {
      try {
        await this.apiStore.getCalibrationTableAction({
          id: this.pmodule?.id as number,
        });
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    });
  }

  @Watch('result')
  async onLoadResult(newVal: any) {
    if (!newVal) return;
    const strParse = JSON.parse(newVal);
    if (strParse) {
      this.data = {
        ...this.data,
        leftX: strParse.data.left_x,
        rightX: strParse.data.right_x,
        values: strParse.data.values,
        size: strParse.data.size,
      };
    }
  }
}
